import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getEvaluationSessionsAction } from '../actions';

const {
  useLoader: useRiskEvaluationsDataLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getEvaluationSessionsAction,
});

function StudentRiskEvaluationSessionsDataLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  StudentRiskEvaluationSessionsDataLoader,
  useRiskEvaluationsDataLoader,
};
